// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type User = {
  uuid: string,
  userId: number,
  name: string,
  photo: string,
  accessToken: string,
  userAgent: string,
  ivCode: string,
  emailConfirmed: boolean,
  introduction: string,
  hasAddress: boolean,
  facebookVerified: boolean,
  smsVerified: boolean,
  isProSeller: boolean,
  invite?: {
    ivCode: string,
    objectType: string,
    objectId: string,
  },
  created: number,
  lastAuthenticatedAt: ?number,
};

export const UserContext: Context<User> = createContext({
  uuid: '',
  userId: 0,
  name: '',
  photo: '',
  accessToken: '',
  userAgent: '',
  ivCode: '',
  emailConfirmed: false,
  introduction: '',
  hasAddress: false,
  facebookVerified: false,
  smsVerified: false,
  isProSeller: false,
  created: 0,
  lastAuthenticatedAt: null,
});
